// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__214Us","col":"styles_col__254DV","fulfillmentStatus":"styles_fulfillmentStatus__2CO6d","emailCol":"styles_emailCol__3tNIl"};